import React, { useEffect, useRef } from "react";
import "./index.css";

const Vendor102 = () => {
    const effectRan = useRef(false);

    useEffect(() => {
        // In React Strict Mode (dev), useEffect runs twice on mount.
        // We prevent the second run by using a ref flag.
        if (effectRan.current) return;
        effectRan.current = true;

        const params = new URLSearchParams(window.location.search);

        const aff_sub = params.get("aff_sub") || "";
        const aff_sub2 = params.get("aff_sub2") || "";
        const aff_click_id = params.get("aff_click_id") || "";
        const fname = params.get("fname") || "";
        const lname = params.get("lname") || "";
        const street = params.get("street") || "";
        const city = params.get("city") || "";
        const state = params.get("state") || "";
        const zipRaw = params.get("zip") || "";
        const phoneRaw = params.get("phone") || "";
        const emailRaw = params.get("email") || "";

        const validateAddress = async (street, city, state, zipRaw) => {
            // Return false immediately if any param is missing or empty
            if (!street || !city || !state || !zipRaw) {
                return false;
            }
        
            const key = '226243467568158435'; // Embedded API key (Browser-safe)
            const fullStreet = `${street} ${city} ${state} ${zipRaw}`.trim();
            const url = `https://us-street.api.smarty.com/street-address` +
                `?key=${key}` +
                `&street=${encodeURIComponent(fullStreet)}`;
        
            try {
                const response = await fetch(url);
                const data = await response.json();
                const isValidAddress =
                    Array.isArray(data) &&
                    data.length > 0 &&
                    data[0]?.metadata?.rdi === 'Residential';
        
                return isValidAddress;
            } catch (error) {
                console.error('Address validation error:', error);
                return false;
            }
        };

        const isValidEmail = (email) =>
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

        const isValidFullName = () => {
            return fname.trim() !== "" && lname.trim() !== "";
        };

        const isValidZip = (zip) => /^\d{5}$/.test(zip);

        const formatPhone = (phone) => {
            const digits = phone.replace(/\D/g, "");
            if (digits.length === 10) return { number: digits, valid: true };
            if (digits.length > 10) return { number: digits.slice(-10), valid: true };
            return { number: null, valid: false };
        };

        const redirectUser = (baseUrl, extraParams) => {
            const url = new URL(baseUrl);
            Object.entries(extraParams).forEach(([key, value]) => {
                if (value) {
                    url.searchParams.set(key, value);
                }
            });
            window.location.href = url.toString();
        };

        const run = async () => {
            const validEmail = isValidEmail(emailRaw);
            const { number, valid } = formatPhone(phoneRaw);
            const validPhone = valid;
            const phoneNumber = number;
            const validName = isValidFullName();
            const validZip = isValidZip(zipRaw);
            const validAddress = await validateAddress(street, city, state, zipRaw);

            const hasAllValidPrepop =
                validName &&
                validAddress &&
                validZip &&
                validEmail &&
                validPhone;

            const queryParams = {
                // campaign_id: 151,
                // hostNameId: 22392,
                // aff_id: 67,
                aff_sub: aff_sub || "",
                aff_sub2: aff_sub2 || "",
                aff_click_id: aff_click_id || "",
                aff_unique2: fname || "",
                aff_sub3: lname || "",
                aff_unique5: street || "",
                aff_sub4: city || "",
                aff_sub5: state || "",
                aff_unique1: zipRaw || "",
                aff_unique4: phoneNumber || "",
                aff_unique3: emailRaw || "",
            };

            try {
                const validityParam = hasAllValidPrepop ? "true" : "false";
                const response = await fetch(
                    `https://api.palisade.ai/checkout/lookup/redirect?vendor_id=102&parameters_validity=${validityParam}`
                );
                if (!response.ok) {
                    throw new Error("Failed to fetch redirect URL");
                }

                const data = await response.json();
                if (data?.data?.redirect_url) {
                    redirectUser(data.data.redirect_url, queryParams);
                } else {
                    throw new Error("Redirect URL not found in response");
                }
            } catch (error) {
                console.error("Redirection failed:", error);
            }
        };

        run();
    }, []);

    return (
        <div className="spinner-container">
            <div className="spinner"></div>
        </div>
    );
};

export default Vendor102;
